import { useMantineColorScheme } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { createTheme, PaletteMode, ThemeProvider } from "@mui/material/styles";
import { NuqsAdapter } from "nuqs/adapters/tanstack-router";
import { useMemo } from "react";

import { MODAL_PROPS, MODALS } from "@/lib/Mantine";
import { MUI_THEME } from "@/lib/MuiMaterial";

const getTheme = (mode: PaletteMode) =>
  createTheme({
    palette: {
      mode
    },
    ...MUI_THEME
  });

export function Providers({ children }: { children: React.ReactNode }) {
  const { colorScheme } = useMantineColorScheme();
  const theme = useMemo(() => getTheme(colorScheme as PaletteMode), [colorScheme]);

  return (
    <ThemeProvider theme={theme}>
      <ModalsProvider modals={MODALS} modalProps={MODAL_PROPS}>
        <NuqsAdapter>{children}</NuqsAdapter>
      </ModalsProvider>
    </ThemeProvider>
  );
}
